import { rootDomain, vercelRelatedProjects } from './env';

export default function getStorePreviewOrigin() {
  let storePreviewProject = null;
  try {
    storePreviewProject = JSON.parse(vercelRelatedProjects)?.find(
      project => project.project.name === 'checkoutpage-mono-store',
    );
  } catch (error) {
    // no-op
  }

  return storePreviewProject?.preview?.branch
    ? `https://${storePreviewProject.preview.branch}`
    : `https://${rootDomain}`;
}
